import logo from '../assets/logo.webp'

export function Logo({ vlak = false }: { vlak?: boolean }) {
  const img = <img src={logo} alt="Truckwash 1 Group" className="logo" width={110} height={26} />
  return vlak ? <span className="logo-vlak">{img}</span> : img
}
